var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "d-flex align-items-center flex-column justify-content-center h-100 w-100 position-relative",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "sidebar-logo clear-fix w-100 d-md-flex d-none justify-content-center my-2 py-2 px-4-5",
        },
        [
          _c("div", { staticClass: "logo" }, [
            _c("a", { staticClass: "clickable" }, [
              _c("img", {
                staticClass: "logo-img",
                attrs: {
                  alt: _vm.$t("global.words.filogixLogo"),
                  src: _vm.$options.filters.getLogo(),
                },
              }),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "sidebar-header row sidebar-row align-items-center w-100 mt-md-3 mb-2 px-4-5",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "col-12 d-flex align-items-center flex-column sidebar-columns",
            },
            [
              _c(
                "profile-avatar",
                _vm._b(
                  { staticClass: "profilepic-options mr-0 mb-3 profilepic" },
                  "profile-avatar",
                  _vm.currentUserDetails,
                  false
                )
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 p-0 sidebar-columns" }, [
            _c(
              "h5",
              {
                staticClass: "text-center m-0 sidebar-user-name",
                attrs: { id: "sidebar-name-container" },
              },
              [
                _c(
                  "span",
                  {
                    attrs: {
                      title: _vm.$options.filters.fullName(
                        _vm.currentUserDetails
                      ),
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm._f("nameFormat")(
                            _vm.currentUserDetails.givenName,
                            _vm.currentUserDetails.familyName
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "h6",
              {
                staticClass:
                  "text-center text-light-gray bold font-sm mt-1 mb-0",
              },
              [
                _c("span", { staticClass: "text-capitalize account-type" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.accountType) + "\n        "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.applicationId
              ? _c(
                  "h6",
                  {
                    staticClass:
                      "text-center text-light-gray bold font-sm mt-1 mb-0",
                  },
                  [
                    _c("span", { staticClass: "text-capitalize" }, [
                      _vm._v(_vm._s(_vm.$t("global.doorr.appId")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "text-capitalize account-app-id" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.applicationId) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      !_vm.IS_FILL_OUT
        ? _c(
            "router-link",
            {
              staticClass: "mt-4 btn btn-primary btn-sm clickable",
              attrs: { to: { name: "dashboard" } },
            },
            [
              _c("i", {
                staticClass: "fa fa-sign-out fa-rotate-180 mr-2",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("global.actions.backToDashboard")) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "sidebar-body mt-4 pt-4 separator-top d-flex flex-column justify-content-between",
        },
        [
          _c("ul", { staticClass: "mb-0" }, [
            _c("li", [
              _c(
                "a",
                {
                  staticClass:
                    "sidetab mb-2 sidetab-active clickable text-center",
                  attrs: { id: "mortgage-application-tab" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("sidebar.sections.mortgageApplication")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "li",
              [
                _vm.applicationId !== ""
                  ? _c(
                      "b-button",
                      {
                        staticClass:
                          "mt-4 ml-4 btn btn-primary btn-sm clickable",
                        attrs: { id: "new-app-btn" },
                        on: { click: _vm.handleNewAppModal },
                      },
                      [
                        _vm._v(
                          "\n          + " +
                            _vm._s(
                              _vm.$t("application.actions.addNewApplication")
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass:
                "sidebar-agent align-items-center w-100 mt-md-3 align-self-center h-100",
            },
            [
              _vm.loading
                ? _c("agent-details-loader")
                : _c(
                    "b-col",
                    {
                      staticClass: "d-flex align-items-center flex-column",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "profile-avatar",
                        _vm._b(
                          {
                            staticClass:
                              "profilepic-options mr-0 mb-3 profilepic",
                          },
                          "profile-avatar",
                          _vm.agentAccountDetails,
                          false
                        )
                      ),
                      _vm._v(" "),
                      _c(
                        "h5",
                        {
                          staticClass:
                            "text-center m-0 sidebar-user-name text-truncate",
                          attrs: { id: "sidebar-name-container" },
                        },
                        [
                          _c(
                            "span",
                            {
                              attrs: {
                                title: _vm.$options.filters.fullName(
                                  _vm.agentAccountDetails
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("fullName")(_vm.agentAccountDetails)
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.agentAccountDetails.phoneNumber
                        ? _c(
                            "h6",
                            {
                              staticClass:
                                "text-center text-light-gray bold font-sm mt-1 mb-0 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text-capitalize account-type" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.agentAccountDetails.phoneNumber
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "h6",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip",
                              value: {
                                title: _vm.agentAccountDetails.email,
                                boundary: "viewport",
                                disabled: !_vm.isEmailTruncated,
                              },
                              expression:
                                "{\n            title: agentAccountDetails.email,\n            boundary: 'viewport',\n            disabled: !isEmailTruncated\n          }",
                            },
                          ],
                          staticClass:
                            "text-center text-light-gray bold font-sm mt-1 mb-0 text-truncate",
                          attrs: { id: "agentEmail" },
                        },
                        [
                          _c("icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.focus.title",
                                value: _vm.$t("application.actions.copied"),
                                expression: "$t('application.actions.copied')",
                                modifiers: { focus: true, title: true },
                              },
                            ],
                            staticClass: "clickable",
                            attrs: { name: "copy", tabindex: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.copyEmail(
                                  _vm.agentAccountDetails.email
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "account-type" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.agentAccountDetails.email) +
                                "\n          "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.agentAccountDetails.licenseRegistrationNumber
                        ? _c(
                            "h6",
                            {
                              staticClass:
                                "text-center text-light-gray bold font-sm mt-1 mb-0 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text-capitalize account-type" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("global.words.agentLicense")
                                      ) +
                                      " #\n            " +
                                      _vm._s(
                                        _vm.agentAccountDetails
                                          .licenseRegistrationNumber
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.licenseType
                        ? _c(
                            "h6",
                            {
                              staticClass:
                                "text-center text-light-gray bold font-sm mt-1 mb-0 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text-capitalize account-type" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("global.words.licenseType")
                                      ) +
                                      ":\n            " +
                                      _vm._s(_vm.licenseType) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.applicationId !== ""
            ? _c("new-app-modal", {
                ref: "addNewApp",
                attrs: { "tied-brokerages": _vm.tiedBrokerages },
                on: { refresh: _vm.handleRefreshPage },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "sidebar-footer d-flex align-items-center justify-content-between text-gray",
        },
        [
          _c(
            "a",
            {
              staticClass: "logout-btn m-0 clickable",
              on: { click: _vm.handleLogout },
            },
            [
              _c("i", {
                staticClass: "fa fa-sign-out fa-rotate-180",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(
                "\n      " + _vm._s(_vm.$t("global.words.logout")) + "\n    "
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }